import type { CreateClientConfig } from './client/client.gen';

export const createClientConfig: CreateClientConfig = (config) => ({
  ...config,
  baseUrl: window.env.API_BASE_URL === "__API_BASE_URL__" ? process.env.REACT_APP_DEV_API_ENDPOINT : window.env.API_BASE_URL,
});